export default __webpack_public_path__ + "7a0db9b15e5e36c055273bf864ecfa06.png";